import { useTranslation } from "react-i18next";
import {
  ComplexListItem,
  DialogStep,
} from "@inductiveautomation/ws-components";

import { PurchaseTestSelectPaymentProps } from "../../Training.types";

export const useSelectPaymentMethodStep = ({
  isOpen,
  onClose,
  purchaseBarProps,
  paymentMethod,
  setPaymentMethod,
  creditsAvailable,
}: PurchaseTestSelectPaymentProps): DialogStep => {
  const { t } = useTranslation("translation", {
    keyPrefix:
      "training.actions.purchase_test.dialog.gold.steps.select_payment_method",
  });

  return {
    label: t("label"),
    substeps: [],
    nextDisabled: !paymentMethod,
    hideSidebar: true,
    variant: "fullWidth",
    dialogProps: {
      isOpen,
      testId: "purchase-test-dialog-contact",
      showCloseButton: true,
      onClose,
      overline: "",
      headline: t("heading"),
      supportingText: t("supporting_text"),
      contentArea: (
        <>
          <ComplexListItem
            id="first"
            heading={t("use_free_credit_option.heading")}
            subtext={t("use_free_credit_option.subtext", {
              remaining: creditsAvailable?.length
                ? creditsAvailable[0].remaining
                : 0,
            })}
            variant={"radio"}
            density={"dialog"}
            onSelection={() => setPaymentMethod("USE_CREDIT")}
            selected={paymentMethod === "USE_CREDIT"}
          ></ComplexListItem>
          <ComplexListItem
            id="second"
            heading={t("do_not_use_credit_option.heading")}
            variant={"radio"}
            density={"dialog"}
            onSelection={() => setPaymentMethod("DO_NOT_USE_CREDIT")}
            selected={paymentMethod === "DO_NOT_USE_CREDIT"}
          ></ComplexListItem>
        </>
      ),
      purchaseBarProps,
    },
  };
};
